"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useListenFocusTriggers = void 0;
const useEventListener_1 = __importDefault(require("../useEventListener"));
const react_1 = require("react");
function useListenFocusTriggers({ ref, onFocusByKeyboard, onFocusByMouse }) {
    const isElementMouseDown = (0, react_1.useRef)(false);
    const onMouseDown = (0, react_1.useCallback)(() => {
        isElementMouseDown.current = true;
    }, [isElementMouseDown]);
    const onFocus = (0, react_1.useCallback)((e) => {
        // if focus triggered by mouse down, call onFocusByMouse
        if (isElementMouseDown.current) {
            onFocusByMouse(e);
        }
        else {
            onFocusByKeyboard(e);
        }
    }, [onFocusByKeyboard, onFocusByMouse]);
    const onMouseUp = (0, react_1.useCallback)(() => {
        isElementMouseDown.current = false;
    }, [isElementMouseDown]);
    (0, useEventListener_1.default)({
        eventName: "mousedown",
        ref,
        callback: onMouseDown
    });
    (0, useEventListener_1.default)({
        eventName: "focus",
        ref,
        callback: onFocus
    });
    (0, useEventListener_1.default)({
        eventName: "mouseup",
        ref,
        callback: onMouseUp
    });
}
exports.useListenFocusTriggers = useListenFocusTriggers;
